export enum TankDisplayStyleEnum {
    LegacyCylinder = "LegacyCylinder",
    SpheroidTower = "SpheroidTower",
    MultiLegTower = "MultiLegTower",
    Standpipe = "Standpipe"
}
